<!-- 
<h1 class="ctn__title">
  {{ 'LOGIN.' + (urlParserService.isEngageHub ? 'TITLE_EHUB' : 'TITLE') | translate }}
</h1>
<p class="ctn__description">
  {{ 'LOGIN.DESCRIPTION' | translate }}
</p>
-->

<amplify-authenticator>
  <amplify-sign-in header-text="Cation Customer Support" slot="sign-in" hide-sign-up="true">
    <!-- Federated sign-in buttons rendered inside the sign-in slot -->
    <div slot="federated-buttons">
      <!-- Change the label/provider to match your Cognito setup -->
      <button class="btn btn-outline-secondary w-100 mb-2" (click)="signInWithProvider('Entra')">
        Sign in with your Corporate Id
      </button>
      <!-- Example for a corporate SAML provider — replace 'MyCorpSSO' with your provider name -->
      <!-- <button class="btn btn-outline-primary w-100 mb-2" (click)="signInWithProvider('MyCorpSSO')">
        Sign in with Corporate SSO
      </button> -->
    </div>
  </amplify-sign-in>
</amplify-authenticator>

<!-- 
<amplify-authenticator [hideSignUp]="true">
  <ng-template amplifySlot="header">
    <h3 class="text-center">Cation Customer Support</h3>
  </ng-template>
</amplify-authenticator>
-->
